import React from "react";
import ProductAccessGate from "@/components/ProductAccessGate";

export default function BrandStudioAccessProvider({ children }) {
  return (
    <ProductAccessGate productSlug="brand-studio" productTitle="Brand Studio" loadingLabel="Загрузка студии…">
      {children}
    </ProductAccessGate>
  );
}
